import { JourneyDataModel } from '../../../../../services/redux/features/journeyData.slice';
import { ContactPersonFormModel_OL } from './formModel';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const requestMapper = (values: ContactPersonFormModel_OL): Partial<JourneyDataModel> => {
  return {};
};
